import {
  BORDER_RADIUS,
  COLORS,
  DEFAULT_TRANSITION_ALL,
  DEFAULT_BOX_SHADOW,
} from "utils/styles";

import Card from "components/Card";
import { IconLink } from "components/IconButton";
import React from "react";
import styled from "styled-components";
import { getFilenamePrefix } from "utils/files";

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 600.01px), @media (hover: hover) {
    ${BORDER_RADIUS};
    ${DEFAULT_TRANSITION_ALL};
    ${DEFAULT_BOX_SHADOW};
    background: rgba(255, 255, 255, 0.95);
    flex-direction: row;
    position: absolute;
    top: 0;
    left: 0;
    right: 15px;
    bottom: 0;
    opacity: 0;
    align-items: center;
    justify-content: center;
    transform: translateX(15px);
  }
`;

const Wrapper = styled(Card)`
  ${DEFAULT_BOX_SHADOW};
  background: ${COLORS.WHITE};
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  grid-column-gap: 1rem;
  padding: 0.5rem 0.5rem 1rem
    ${({ hasImage }) => (hasImage ? "0.5rem" : "1rem")};
  margin-bottom: 1rem;
  position: relative;

  &:hover {
    ${LinkWrapper} {
      opacity: 1;
      transform: translateX(0);
      right: 0;
    }
  }
`;

const Image = styled.img`
  ${BORDER_RADIUS};
  width: 106px;
  height: 100%;
  object-fit: cover;

  @media (min-width: 30em) {
    width: 212px;
  }
  @media (min-width: 50em) {
    width: 106px;
  }
  @media (min-width: 60em) {
    width: 212px;
  }

  ${({ small }) => {
    return small ? "width: 106px !important" : "";
  }};
`;

const Content = styled.div`
  padding-top: 0.375rem;
`;
const Title = styled.span.attrs(() => ({
  className: "mabry-medium",
}))`
  display: block;
  font-size: 1.125rem;
  margin-bottom: 0.125rem;
  font-weight: 500;
`;
const Subtitle = styled.span`
  font-size: 0.875rem;
  word-break: ${({ wordBreak }) => wordBreak};
`;

const Link = styled.a`
  display: block;
  color: ${COLORS.DARKEST_GRAY};
  text-decoration: none;
  font-size: 1.125rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;

  &:hover,
  &:focus {
    color: ${COLORS.BLACK};
    text-decoration: none;
  }

  &:not(:first-child) {
    margin-left: 1.25rem;
    border-left: 1px solid ${COLORS.DARKEST_GRAY};
    padding-left: 1.25rem;
  }

  @media (max-width: 600px), @media (hover: none) {
    font-size: 0.75rem;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;

    & > i {
      font-size: 0.75rem !important;
      transform: translateY(2px);
    }
  }
`;
const LinkIcon = styled.i`
  color: inherit;
  transform: translateY(4px);
  margin-right: 4px;
`;

function Artifact({
  imageAlt,
  imageUrl,
  title,
  subtitle,
  subtitleWordBreak = "break-word",
  small,
  externalHref,
  feedHref,
}) {
  if (!imageAlt) {
    console.warn("No image alt tag for Artifact", title, subtitle);
  }
  const imgSrcPrefix = getFilenamePrefix(imageUrl);
  return (
    <Wrapper hasImage={Boolean(imageUrl)}>
      {imageUrl ? (
        <picture small={small}>
          <source srcSet={`${imgSrcPrefix}.webp`} type="image/webp" />
          <source srcSet={`${imgSrcPrefix}.png`} type="image/png" />
          <Image
            alt={imageAlt}
            loading={small ? "lazy" : "eager"}
            src={imageUrl}
          />
        </picture>
      ) : null}
      <Content>
        <Title>{title}</Title>
        <Subtitle wordBreak={subtitleWordBreak}>{subtitle}</Subtitle>
        {!small && (feedHref || externalHref) ? (
          <LinkWrapper>
            {feedHref ? (
              <Link href={feedHref}>
                <LinkIcon className="material-icons-round md-dark">
                  view_stream
                </LinkIcon>
                Explore Feed
              </Link>
            ) : null}
            {externalHref ? (
              <Link target="blank" href={externalHref}>
                <LinkIcon className="material-icons-round md-dark">
                  open_in_new
                </LinkIcon>
                View External Link
              </Link>
            ) : null}
          </LinkWrapper>
        ) : null}
      </Content>
      {/* {href ? (
        <Link href={href}>
          <LinkIcon className="material-icons-round mr-2">
            chevron_right
          </LinkIcon>
        </Link>
      ) : null} */}
    </Wrapper>
  );
}

export default Artifact;
